<script>
    import Icon from '../icons/Icon.svelte';

    export let storeName = '';
    export let businessProfile = '';
    export let pixKey = '';
    export let operatingSchedule = [];
    export let acceptDelivery = true;
    export let acceptPickup = true;
    export let acceptDineIn = true;
    export let onNavigateTab = () => {};

    $: hasNiche = Boolean(businessProfile && businessProfile.trim());
    $: hasIdentity = Boolean(storeName && storeName.trim());
    $: hasPix = Boolean(pixKey && pixKey.trim());
    $: hasSchedule = Array.isArray(operatingSchedule) && operatingSchedule.some(s => !s.is_closed);
    $: hasChannels = Boolean(acceptDelivery || acceptPickup || acceptDineIn);

    $: completedCount = [hasNiche, hasIdentity, hasPix, hasSchedule, hasChannels].filter(Boolean).length;
    $: progressPercent = Math.round((completedCount / 5) * 100);
</script>

<div class="readiness-card">
    <div class="readiness-top">
        <div class="readiness-info">
            <div class="readiness-badge-row">
                <span class="readiness-badge {progressPercent === 100 ? 'complete' : 'progress'}">
                    <Icon name={progressPercent === 100 ? 'check-circle' : 'zap'} size={14} />
                    <span>{progressPercent === 100 ? 'LOJA 100% PRONTA' : 'CONFIGURAÇÃO INICIAL'}</span>
                </span>
                <span class="readiness-score">{progressPercent}% pronta para vender</span>
            </div>
            <p class="readiness-desc">
                {#if progressPercent === 100}
                    Excelente! Seu restaurante possui todos os parâmetros essenciais ativos para receber pedidos no cardápio, salão e WhatsApp.
                {:else}
                    Complete os itens abaixo para garantir que o cardápio digital, recebimentos PIX e o robô de WhatsApp funcionem perfeitamente.
                {/if}
            </p>
        </div>

        <div class="progress-bar-container">
            <div class="progress-bar-fill" style="width: {progressPercent}%"></div>
        </div>
    </div>

    <div class="readiness-checklist">
        <!-- 1. Ramo -->
        <button type="button" class="check-item {hasNiche ? 'done' : 'pending'}" on:click={() => onNavigateTab(1)}>
            <div class="check-icon">
                <Icon name={hasNiche ? 'check' : 'alert-triangle'} size={13} />
            </div>
            <div class="check-text">
                <span class="check-title">Ramo do Estabelecimento</span>
                <span class="check-status">{hasNiche ? 'Definido' : 'Pendente'}</span>
            </div>
        </button>

        <!-- 2. Identidade -->
        <button type="button" class="check-item {hasIdentity ? 'done' : 'pending'}" on:click={() => onNavigateTab(1)}>
            <div class="check-icon">
                <Icon name={hasIdentity ? 'check' : 'alert-triangle'} size={13} />
            </div>
            <div class="check-text">
                <span class="check-title">Nome & Link</span>
                <span class="check-status">{hasIdentity ? 'Configurado' : 'Pendente'}</span>
            </div>
        </button>

        <!-- 3. PIX -->
        <button type="button" class="check-item {hasPix ? 'done' : 'pending'}" on:click={() => onNavigateTab(3)}>
            <div class="check-icon">
                <Icon name={hasPix ? 'check' : 'alert-triangle'} size={13} />
            </div>
            <div class="check-text">
                <span class="check-title">Chave PIX</span>
                <span class="check-status">{hasPix ? 'Ativa' : 'Falta cadastrar'}</span>
            </div>
        </button>

        <!-- 4. Horários -->
        <button type="button" class="check-item {hasSchedule ? 'done' : 'pending'}" on:click={() => onNavigateTab(4)}>
            <div class="check-icon">
                <Icon name={hasSchedule ? 'check' : 'alert-triangle'} size={13} />
            </div>
            <div class="check-text">
                <span class="check-title">Horário Semanal</span>
                <span class="check-status">{hasSchedule ? 'Definido' : 'Falta ajustar'}</span>
            </div>
        </button>

        <!-- 5. Canais -->
        <button type="button" class="check-item {hasChannels ? 'done' : 'pending'}" on:click={() => onNavigateTab(2)}>
            <div class="check-icon">
                <Icon name={hasChannels ? 'check' : 'alert-triangle'} size={13} />
            </div>
            <div class="check-text">
                <span class="check-title">Canais de Venda</span>
                <span class="check-status">{hasChannels ? 'Ativos' : 'Pendente'}</span>
            </div>
        </button>
    </div>
</div>

<style>
    .readiness-card {
        background: #FFFFFF;
        border: 1px solid #E2E8F0;
        border-radius: 12px;
        padding: 18px 22px;
        margin-bottom: 22px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.03);
    }

    .readiness-top {
        margin-bottom: 14px;
    }

    .readiness-badge-row {
        display: flex;
        align-items: center;
        gap: 12px;
        margin-bottom: 6px;
    }

    .readiness-badge {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        font-size: 11px;
        font-weight: 700;
        letter-spacing: 0.04em;
        padding: 4px 10px;
        border-radius: 6px;
    }

    .readiness-badge.complete {
        background: #DCFCE7;
        color: #15803D;
        border: 1px solid #BBF7D0;
    }

    .readiness-badge.progress {
        background: #FEF3C7;
        color: #B45309;
        border: 1px solid #FDE68A;
    }

    .readiness-score {
        font-size: 14px;
        font-weight: 700;
        color: #0F172A;
    }

    .readiness-desc {
        font-size: 13px;
        color: #64748B;
        margin: 0 0 10px 0;
        line-height: 1.4;
    }

    .progress-bar-container {
        height: 6px;
        background: #F1F5F9;
        border-radius: 999px;
        overflow: hidden;
    }

    .progress-bar-fill {
        height: 100%;
        background: linear-gradient(90deg, #FF6A00, #22C55E);
        border-radius: 999px;
        transition: width 0.35s ease;
    }

    .readiness-checklist {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
        gap: 10px;
    }

    .check-item {
        display: flex;
        align-items: center;
        gap: 10px;
        background: #F8FAFC;
        border: 1px solid #E2E8F0;
        border-radius: 8px;
        padding: 9px 12px;
        text-align: left;
        cursor: pointer;
        transition: all 0.15s ease;
    }

    .check-item:hover {
        background: #F1F5F9;
        border-color: #CBD5E1;
        transform: translateY(-1px);
    }

    .check-icon {
        width: 22px;
        height: 22px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
    }

    .check-item.done .check-icon {
        background: #DCFCE7;
        color: #15803D;
    }

    .check-item.pending .check-icon {
        background: #FEF3C7;
        color: #B45309;
    }

    .check-text {
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }

    .check-title {
        font-size: 12px;
        font-weight: 700;
        color: #0F172A;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    .check-status {
        font-size: 11px;
        color: #64748B;
    }

    .check-item.done .check-status {
        color: #16A34A;
        font-weight: 600;
    }

    .check-item.pending .check-status {
        color: #D97706;
    }
</style>
